import {
  DefaultMenuItem,
  GetContextMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-community'
import { TicketTypeRow } from '../TicketTypeRow'
import {
  addRowMenuItems,
  addMultipleRowsMenuItem,
  deleteRowMenuItems,
} from '../gridOptions/contextMenu'
import { getSelectedNode } from '../../../containers/BulkSheetView/lib/gridApi'

/**
 * ag-Grid の行スタイルを決定する関数
 * プリセット行をグレーアウトする
 */
export const getRowStyle = (params: any) => {
  if (params.data && params.data.isPreset) {
    return { backgroundColor: '#e0e0e0' }
  }
}

/**
 * コンテキストメニューを生成する関数
 */
export const createContextMenuItems = (
  params: GetContextMenuItemsParams,
  rowData: TicketTypeRow[],
  handleSetData: (newData: TicketTypeRow[], newRows: TicketTypeRow[]) => void,
  handleDeleteRows: () => void,
  handleOpenMultipleRowDialog: () => void
): (DefaultMenuItem | MenuItemDef)[] => {
  const selectedNodes = getSelectedNode(params.api)

  return [
    ...addRowMenuItems(params, rowData, handleSetData),
    addMultipleRowsMenuItem(handleOpenMultipleRowDialog),
    'separator',
    ...deleteRowMenuItems(selectedNodes, handleDeleteRows),
  ]
}
